{{each list}}
<li>
    <a href="/organization/orgdetail?id={{$value.id}}">
        <span><img src="{{$value.avatar}}" alt=""></span>
        <p class="single-title">{{$value.value}}</p>
        <!--<p>山西省科协-科员山西省科协-科员</p>-->
    </a>
    {{if $value.status == 0}}
    <button class="follow-skin  _followBtn"  data-id="{{$value.id}}">加关注</button>
    {{else $value.status == 1}}
    <button class="follow-skin unfollow-skin _notFollowBtn" data-id="{{$value.id}}">已关注</button>
    {{/if}}
</li>
{{/each}}